export default __webpack_public_path__ + "static/css/maps.static.css";